import React from 'react';
import getCurrencySymbol from 'currency-symbol-map';
import PropTypes from 'prop-types';

import { ModalPaymentButtonWrapper, UiIndicator } from '../common-field-styles';
import { ctrlDefaults } from '../../../shared/form-lib';
import { ControlPropType } from '../ctrl_proptype';

const PaymentModalButton = ({ ctrl, amount, onClick, errorMessage, isNoKeyAvailable, isTestMode, isCompleted }) => {
  const { label, required, currency } = ctrl.props;
  const buttonLabel = label || ctrlDefaults()[ctrl.type];

  return (
    <ModalPaymentButtonWrapper
      hasBottomElement={errorMessage || isTestMode}
      hasTopElement={isNoKeyAvailable}
      onClick={onClick}
      type="button">
      {isNoKeyAvailable && (
        <UiIndicator className="status red">
          <span>
            The form owner has not set up their payment integration. Please contact the owner for more information.
          </span>
        </UiIndicator>
      )}

      <div className="top">
        <span className="merchant">{`${buttonLabel} - ${getCurrencySymbol(currency || 'USD')}${amount}`}</span>

        {isCompleted && (
          <span className="completed">
            <img src="https://storage.googleapis.com/fplsblog/checkbox-green.svg" alt="check-icon" />
            Completed
          </span>
        )}

        {!isCompleted && (
          <span className={required ? 'required' : 'optional'}>{required ? '*Required' : 'Optional'}</span>
        )}
      </div>

      {errorMessage && (
        <UiIndicator className="status red">
          <span>{errorMessage}</span>
        </UiIndicator>
      )}

      {isTestMode && <UiIndicator className="mode">Test mode</UiIndicator>}
    </ModalPaymentButtonWrapper>
  );
};

PaymentModalButton.propTypes = {
  ctrl: PropTypes.shape(ControlPropType).isRequired,
  isNoKeyAvailable: PropTypes.bool.isRequired,
  errorMessage: PropTypes.string.isRequired,
  isCompleted: PropTypes.bool.isRequired,
  amount: PropTypes.number.isRequired,
  onClick: PropTypes.func.isRequired,
  isTestMode: PropTypes.bool,
};

PaymentModalButton.defaultProps = {
  isTestMode: true,
};

export default PaymentModalButton;
